import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService, HttpService } from '../../../services';
import { REGEX } from '../../../constants/regex';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiResponse } from 'src/app/models/common';
import { IGSTRequest } from 'src/app/models/request/IRequest';
import { FlightService } from 'src/app/services/flight.service';

@Component({
  selector: 'app-gst',
  templateUrl: './gst.component.html',
  styleUrls: ['./gst.component.scss']
})
export class GSTComponent implements OnInit {
  gstShow = false;
  gstInformation: FormGroup;
  submitted: boolean;
  gstList;
  gstLists;
  gst_customer_number = new FormControl('', [Validators.required, Validators.pattern(REGEX.GST)]);
  gst_company_name = new FormControl('', Validators.required);
  gst_email_id = new FormControl('', [Validators.required, Validators.pattern(REGEX.EMAIL)]);
  customerAddress = new FormControl('', Validators.required);
  constructor( private fb: FormBuilder, private data: DataService, private snackbar: MatSnackBar, private dialog: MatDialogRef<GSTComponent>, private router: Router,
    private route: ActivatedRoute, public flight: FlightService, @Inject(MAT_DIALOG_DATA) public matData: any,) {
    this.gstInformation = this.fb.group({
      gst_customer_number: this.gst_customer_number,
      gst_company_name: this.gst_company_name,
      gst_email_id: this.gst_email_id,
      customerAddress: this.customerAddress,
    });
    this.gstInformation.patchValue(this.gstLists);
  }

  ngOnInit(): void {
    this.gstList = this.data.gstInfo,
    this.gstInformation.patchValue({
      gstList: this.data.gstInfo,
    })
  }

  submit() {
    if(this.gstInformation.valid) {
      this.data.gstInfo.push(this.gstInformation.value);
      this.dialog.close(this.matData);
    }
  }
}
